import { render, staticRenderFns } from "./NestingProposalItem.vue?vue&type=template&id=048dbe7c&"
import script from "./NestingProposalItem.vue?vue&type=script&lang=js&"
export * from "./NestingProposalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports